import { getStatusChatInstanceId } from "./streamChatUnreadUtils";

function normalizePathname(pathname = "") {
	const normalized = String(pathname || "").trim().replace(/\/+$/, "");
	return normalized || "/";
}

export function buildStatusRouteFromChatLocation(location = {}) {
	if (normalizePathname(location.pathname) !== "/chat") {
		return "";
	}

	let channelId = "";
	try {
		const params = new URLSearchParams(String(location.search || ""));
		channelId = params.get("channel_id") || params.get("channelId") || "";
	} catch (_err) {
		return "";
	}

	const instanceId = getStatusChatInstanceId(channelId);
	return instanceId
		? `/searchHistory/instance/${encodeURIComponent(instanceId)}`
		: "";
}
